export default "__VITE_ASSET__Bo0$61zf__"